(function () {
    const $ = s => document.querySelector(s);
    let qty = 1;

    function openCart() { if (window.openCart) window.openCart(); }
    function closeCart() { if (window.closeCart) window.closeCart(); }

    // ---- Gallery ----
    function showMedia(mediaId) {
        if (!mediaId) return false;

        const slide = document.querySelector(
            '.product-gallery-slide[data-media-id="' + mediaId + '"]'
        );

        if (!slide) return false;

        const currentSlide = document.querySelector(
            '.product-gallery-slide.active'
        );

        // Already showing this image
        if (currentSlide === slide) {
            return true;
        }

        document.querySelectorAll('.product-gallery-slide').forEach(s => {
            s.classList.remove('active');
        });

        document.querySelectorAll('.product-thumb').forEach(t => {
            t.classList.remove('active');
        });

        slide.classList.add('active');

        const thumb = document.querySelector(
            '.product-thumb[data-media-id="' + mediaId + '"]'
        );

        if (thumb) {
            thumb.classList.add('active');
        }

        return true;
    }

    document.querySelectorAll('.product-thumb').forEach(thumb => {
        thumb.addEventListener('click', () => showMedia(thumb.dataset.mediaId));
    });

    // ---- Lightbox & Zoom Logic ----
    const galleryMain = $('.product-gallery-main');
    
    // Lightbox elements
    const lightbox = $('#pdpLightbox');
    const lightboxClose = $('#pdpLightboxClose');
    const lightboxPrev = $('#pdpLightboxPrev');
    const lightboxNext = $('#pdpLightboxNext');
    const lightboxImg = $('#pdpLightboxImg');
    const lightboxTrack = $('#pdpLightboxTrack');
    
    let isLightboxOpen = false;
    let isZoomed = false;
    let isDragging = false;
    let zoomScale = 1;
    let currentX = 0;
    let currentY = 0;
    let initialX = 0;
    let initialY = 0;

    function resetZoom() {
        isZoomed = false;
        zoomScale = 1;
        currentX = 0;
        currentY = 0;
        if (lightboxImg) lightboxImg.style.transform = `scale(1) translate(0px, 0px)`;
        if (lightboxTrack) lightboxTrack.classList.remove('is-zoomed', 'is-dragging');
    }

    function syncLightboxImage(isOpening = false) {
        const activeSlideImg = document.querySelector('.product-gallery-slide.active img');
        if (activeSlideImg && lightboxImg) {
            if (isOpening) {
                lightboxImg.src = activeSlideImg.src;
                lightboxImg.classList.remove('fading-out');
                resetZoom();
            } else {
                lightboxImg.classList.add('fading-out');
                setTimeout(() => {
                    lightboxImg.src = activeSlideImg.src;
                    resetZoom();
                    setTimeout(() => lightboxImg.classList.remove('fading-out'), 50);
                }, 300); // Wait for fade out CSS transition
            }
        }
    }

    function openLightbox() {
        if (!lightbox) return;
        syncLightboxImage(true);
        lightbox.style.display = '';
        lightbox.style.visibility = '';
        requestAnimationFrame(() => {
            lightbox.classList.add('open');
        });
        isLightboxOpen = true;
        document.body.style.overflow = 'hidden';
    }

    function closeLightbox() {
        if (!lightbox) return;
        lightbox.classList.remove('open');
        isLightboxOpen = false;
        document.body.style.overflow = '';
        resetZoom();
        setTimeout(() => {
            if (!isLightboxOpen) {
                lightbox.style.display = 'none';
                lightbox.style.visibility = 'hidden';
            }
        }, 400);
    }

    if (lightboxClose) lightboxClose.addEventListener('click', closeLightbox);
    
    if (lightboxTrack) {
        let dragCheckX = 0;
        let dragCheckY = 0;
        let didDrag = false;

        lightboxTrack.addEventListener('pointerdown', (e) => {
            if (!isZoomed) return;
            isDragging = true;
            didDrag = false;
            dragCheckX = e.clientX;
            dragCheckY = e.clientY;
            lightboxTrack.classList.add('is-dragging');
            initialX = e.clientX - currentX;
            initialY = e.clientY - currentY;
            lightboxTrack.setPointerCapture(e.pointerId);
        });

        lightboxTrack.addEventListener('pointermove', (e) => {
            if (!isDragging || !isZoomed) return;
            e.preventDefault();
            if (Math.abs(e.clientX - dragCheckX) > 5 || Math.abs(e.clientY - dragCheckY) > 5) {
                didDrag = true;
            }
            currentX = e.clientX - initialX;
            currentY = e.clientY - initialY;
            lightboxImg.style.transform = `scale(${zoomScale}) translate(${currentX / zoomScale}px, ${currentY / zoomScale}px)`;
        });

        const stopDrag = (e) => {
            if (!isDragging) return;
            isDragging = false;
            lightboxTrack.classList.remove('is-dragging');
            if (lightboxTrack.hasPointerCapture(e.pointerId)) {
                lightboxTrack.releasePointerCapture(e.pointerId);
            }
        };

        lightboxTrack.addEventListener('pointerup', stopDrag);
        lightboxTrack.addEventListener('pointercancel', stopDrag);

        lightboxTrack.addEventListener('click', (e) => {
            if (didDrag) return; 
            isZoomed = !isZoomed;
            if (isZoomed) {
                lightboxTrack.classList.add('is-zoomed');
                zoomScale = 2.4; 
                lightboxImg.style.transform = `scale(${zoomScale}) translate(${currentX / zoomScale}px, ${currentY / zoomScale}px)`;
            } else {
                resetZoom();
            }
        });
    }

    if (galleryMain) {
        galleryMain.addEventListener('click', (e) => {
            if (e.target.closest('.seepa-gallery-nav')) return; // ignore arrow clicks
            openLightbox();
        });

        let scrollTimeout;
        galleryMain.addEventListener('scroll', () => {
            clearTimeout(scrollTimeout);
            scrollTimeout = setTimeout(() => {
                let activeIndex = Math.round(galleryMain.scrollLeft / galleryMain.clientWidth);
                const slides = Array.from(galleryMain.querySelectorAll('.product-gallery-slide:not(.filtered-out)'));
                if (slides[activeIndex]) {
                    const mediaId = slides[activeIndex].dataset.mediaId;
                    document.querySelectorAll('.product-gallery-slide').forEach(s => s.classList.remove('active'));
                    document.querySelectorAll('.product-thumb').forEach(t => t.classList.remove('active'));

                    slides[activeIndex].classList.add('active');
                    const thumb = document.querySelector('.product-thumb[data-media-id="' + mediaId + '"]');
                    if (thumb) thumb.classList.add('active');
                }
            }, 50);
        });

        const prevBtn = $('.seepa-gallery-nav.prev');
        const nextBtn = $('.seepa-gallery-nav.next');

        function navigateGallery(direction) {
            const slides = Array.from(
                document.querySelectorAll(
                    '.product-gallery-slide:not(.filtered-out)'
                )
            );

            if (!slides.length) return;

            let activeIndex = slides.findIndex(
                s => s.classList.contains('active')
            );

            if (activeIndex === -1) {
                activeIndex = 0;
            }

            let newIndex = activeIndex + direction;

            if (newIndex < 0) {
                newIndex = slides.length - 1;
            }

            if (newIndex >= slides.length) {
                newIndex = 0;
            }

            showMedia(slides[newIndex].dataset.mediaId);
        }

        if (prevBtn) {
            prevBtn.addEventListener('click', (e) => {
                e.stopPropagation();
                navigateGallery(-1);
            });
        }

        if (nextBtn) {
            nextBtn.addEventListener('click', (e) => {
                e.stopPropagation();
                navigateGallery(1);
            });
        }


        if (lightboxPrev) {
            lightboxPrev.addEventListener('click', (e) => {
                e.stopPropagation();
                navigateGallery(-1);
                syncLightboxImage();
            });
        }

        if (lightboxNext) {
            lightboxNext.addEventListener('click', (e) => {
                e.stopPropagation();
                navigateGallery(1);
                syncLightboxImage();
            });
        }

        // ---- Desktop keyboard gallery navigation ----
        document.addEventListener('keydown', (event) => {

            if (event.key === 'Escape' && isLightboxOpen) {
                closeLightbox();
                return;
            }

            if (window.innerWidth <= 768 && !isLightboxOpen) return;

            const tag = document.activeElement?.tagName;

            if (
                tag === 'INPUT' ||
                tag === 'TEXTAREA' ||
                tag === 'SELECT' ||
                document.activeElement?.isContentEditable
            ) {
                return;
            }

            if (
                event.key !== 'ArrowLeft' &&
                event.key !== 'ArrowRight'
            ) {
                return;
            }

            event.preventDefault();

            if (event.key === 'ArrowLeft') {
                navigateGallery(-1);
                if (isLightboxOpen) syncLightboxImage();
            }

            if (event.key === 'ArrowRight') {
                navigateGallery(1);
                if (isLightboxOpen) syncLightboxImage();
            }
        });
    }

    // ---- Options / variant matching ----
    function getSelectedOptions() {
        const values = [];
        document.querySelectorAll('#pdpSwatches, #pdpSizes').forEach(group => {
            const active = group.querySelector('button.active');
            values[parseInt(group.dataset.optionIndex, 10)] = active ? active.dataset.value : null;
        });
        return values;
    }

    function findVariant() {
        if (!window.SEEPA_VARIANTS) return null;
        const selected = getSelectedOptions();
        return window.SEEPA_VARIANTS.find(v => {
            const opts = [v.option1, v.option2, v.option3];
            return selected.every((val, i) => val == null || opts[i] === val);
        });
    }

    function updateAvailability() {
        const selectedOptions = getSelectedOptions();

        document.querySelectorAll('#pdpSwatches button, #pdpSizes button').forEach(btn => {
            const group = btn.closest('[data-option-index]');
            const optIndex = parseInt(group.dataset.optionIndex, 10);
            const isColor = group.id === 'pdpSwatches';

            if (isColor) {
                const colorValue = btn.dataset.value;
                const hasAnyStock = window.SEEPA_VARIANTS && window.SEEPA_VARIANTS.some(v => {
                    const opts = [v.option1, v.option2, v.option3];
                    return opts[optIndex] === colorValue && v.available;
                });
                btn.disabled = !hasAnyStock;
            } else {
                const testSelection = [...selectedOptions];
                testSelection[optIndex] = btn.dataset.value;
                const match = window.SEEPA_VARIANTS && window.SEEPA_VARIANTS.find(v => {
                    const opts = [v.option1, v.option2, v.option3];
                    return testSelection.every((val, i) => val == null || opts[i] === val);
                });
                btn.disabled = match ? !match.available : false;
            }
        });
    }

    function syncUI() {
        const variant = findVariant();

        document.querySelectorAll('[data-option-index]').forEach(group => {
            const active = group.querySelector('button.active');
            const labelEl = document.querySelector('.selected-value[data-option-index="' + group.dataset.optionIndex + '"]');
            if (labelEl && active) labelEl.textContent = active.dataset.value;
        });

        if ($('#pdpQty')) $('#pdpQty').textContent = qty;

        const addBtn = $('#pdpAddCart');
        const stickyBtn = $('#stickyAddCart');
        const variantInput = $('#pdpVariantId');

        // ---- IMAGE SWITCHING ----
        // Set the image directly from the variant's real CDN url (variant.featured_image.src),
        // instead of trying to match gallery media IDs (which can be unreliable).
        // ---- IMAGE SWITCHING ----
        // ---- IMAGE SWITCHING + COLOR FILTERING ----
        (function updateGalleryForColor() {

            const colorGroup = $('#pdpSwatches');

            if (!colorGroup || !window.SEEPA_VARIANTS) return;

            const activeColorBtn = colorGroup.querySelector('button.active');

            if (!activeColorBtn) return;

            const colorValue = activeColorBtn.dataset.value;

            function handleize(str) {
                return String(str)
                    .toLowerCase()
                    .replace(/[^a-z0-9]+/g, '-')
                    .replace(/(^-|-$)/g, '');
            }

            const colorHandle = handleize(colorValue);

            // Allow common naming variations
            const colorSynonyms = {
                beige: ['beige', 'cream', 'khaki', 'sand'],
                cream: ['cream', 'beige', 'khaki', 'sand'],
                navy: ['navy', 'blue', 'dark-blue'],
                blue: ['blue', 'navy'],
                white: ['white', 'snow'],
                black: ['black', 'dark', 'charcoal'],
                grey: ['grey', 'gray'],
                gray: ['gray', 'grey']
            };

            const activeKeywords =
                colorSynonyms[colorHandle] || [colorHandle];

            let firstVisibleMediaId = null;

            // -------------------------
            // FILTER MAIN GALLERY
            // -------------------------

            document.querySelectorAll('.product-gallery-slide').forEach(slide => {

                const slideColor =
                    (slide.dataset.color || '').toLowerCase();

                const img = slide.querySelector('img');

                const src =
                    img && img.src
                        ? img.src.toLowerCase()
                        : '';

                const isMatch = activeKeywords.some(keyword =>
                    slideColor.includes(keyword) ||
                    src.includes(keyword)
                );

                if (isMatch) {

                    slide.classList.remove('filtered-out');

                    if (!firstVisibleMediaId && slide.dataset.mediaId) {
                        firstVisibleMediaId = slide.dataset.mediaId;
                    }

                } else {

                    slide.classList.add('filtered-out');

                }
            });


            // -------------------------
            // FILTER THUMBNAILS
            // -------------------------

            document.querySelectorAll('.product-thumb').forEach(thumb => {

                const thumbColor =
                    (thumb.dataset.color || '').toLowerCase();

                const img = thumb.querySelector('img');

                const src =
                    img && img.src
                        ? img.src.toLowerCase()
                        : '';

                const isMatch = activeKeywords.some(keyword =>
                    thumbColor.includes(keyword) ||
                    src.includes(keyword)
                );

                if (isMatch) {
                    thumb.classList.remove('filtered-out');
                } else {
                    thumb.classList.add('filtered-out');
                }

            });


            // -------------------------
            // SHOW FIRST IMAGE OF COLOR
            // -------------------------

            const activeSlide =
                document.querySelector('.product-gallery-slide.active');

            if (
                !activeSlide ||
                activeSlide.classList.contains('filtered-out')
            ) {

                if (firstVisibleMediaId) {
                    showMedia(firstVisibleMediaId);
                }

            }

        })();

        if (variant) {
            if (variantInput) variantInput.value = variant.id;
            const available = variant.available;
            if (addBtn) {
                addBtn.disabled = !available;
                addBtn.textContent = available ? 'ADD TO CART' : 'OUT OF STOCK';
            }
            if (stickyBtn) {
                stickyBtn.disabled = !available;
                stickyBtn.textContent = available ? 'ADD TO CART' : 'SOLD OUT';
            }
            const priceEl = $('#stickyAtcPrice');
            if (priceEl && variant.price != null) {
                priceEl.textContent = (variant.price / 100).toLocaleString(undefined, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' }).replace(/Dhs\.?/g, 'AED');
            }
        }
        updateAvailability();
    }


    document.querySelectorAll('#pdpSwatches button, #pdpSizes button').forEach(btn => {
        btn.addEventListener('click', () => {
            const group = btn.closest('[data-option-index]');

            group.querySelectorAll('button').forEach(b => {
                b.classList.remove('active');
            });

            btn.classList.add('active');

            syncUI();
        });
    });


    if ($('#pdpPlus')) $('#pdpPlus').onclick = () => { qty++; syncUI(); };
    if ($('#pdpMinus')) $('#pdpMinus').onclick = () => { qty = Math.max(1, qty - 1); syncUI(); };

    // ---- Size guide modal ----
    const sizeGuideModal = $('#sizeGuideModal');
    const sizeGuideBackdrop = $('#sizeGuideBackdrop');
    function openSizeGuide() { if (sizeGuideModal) { sizeGuideModal.classList.add('open'); sizeGuideBackdrop.classList.add('open'); } }
    function closeSizeGuide() { if (sizeGuideModal) { sizeGuideModal.classList.remove('open'); sizeGuideBackdrop.classList.remove('open'); } }
    if ($('#sizeGuideOpen')) $('#sizeGuideOpen').addEventListener('click', openSizeGuide);
    if ($('#sizeGuideClose')) $('#sizeGuideClose').addEventListener('click', closeSizeGuide);
    if (sizeGuideBackdrop) sizeGuideBackdrop.addEventListener('click', closeSizeGuide);

    // ---- Add to cart (shared for both main + sticky buttons) ----
    async function addToCart(button) {
        if (!button || button.dataset.loading === 'true' || button.disabled) return;

        const variantId = ($('#pdpVariantId') && $('#pdpVariantId').value) || (window.SEEPA_PRODUCT && window.SEEPA_PRODUCT.selectedVariantId);
        if (!variantId) return;

        const originalHTML = button.innerHTML;
        button.dataset.loading = 'true';
        button.disabled = true;
        button.innerHTML = '<span class="add-cart-spinner"></span><span>ADDING...</span>';

        try {
            const res = await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] })
            });
            if (!res.ok) throw new Error('Add to cart failed');

            button.dataset.loading = 'false';
            button.disabled = false;
            button.innerHTML = originalHTML;

            if (window.renderDrawerFromCart) {
                await window.renderDrawerFromCart();
            }
            openCart();
        } catch (e) {
            console.error('Add to cart error', e);
            button.dataset.loading = 'false';
            button.disabled = false;
            button.innerHTML = 'TRY AGAIN';
            setTimeout(() => { button.innerHTML = originalHTML; }, 1500);
        }
    }

    if ($('#pdpAddCart')) $('#pdpAddCart').addEventListener('click', function () { addToCart(this); });
    if ($('#stickyAddCart')) $('#stickyAddCart').addEventListener('click', function () { addToCart(this); });

    // ---- Sticky mobile add-to-cart visibility ----
    const stickyAtc = $('#stickyAtc');
    const mainBuyRow = document.querySelector('.buy-row');
    if (stickyAtc && mainBuyRow) {
        const stickyObserver = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    stickyAtc.classList.remove('visible');
                } else {
                    // Only show once user has scrolled past the main buy row (not before it's rendered)
                    if (entry.boundingClientRect.top < 0) {
                        stickyAtc.classList.add('visible');
                    }
                }
            });
        }, { threshold: 0 });
        stickyObserver.observe(mainBuyRow);
    }

    fetchCartCountSafe();
    syncUI();

    function fetchCartCountSafe() {
        fetch('/cart.js').then(r => r.json()).then(cart => {
            const el = $('#cartCount');
            if (el) el.textContent = cart.item_count;
        }).catch(() => { });
    }



})();

/* ============================================================
   Pumper Bundler <-> product gallery color sync
   Add this as a NEW <script> tag right after your existing
   {{ 'product.js' | asset_url | script_tag }} line in the
   product template (or paste the contents into product.js
   itself, after the closing `})();` of the existing IIFE).

   Behavior: all gallery images stay visible at all times.
   When a color is selected in Pumper, the carousel just
   scrolls/jumps to the first image whose alt text matches
   that color -- nothing is hidden.
   ============================================================ */
(function () {
    function handleize(str) {
        return String(str)
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/(^-|-$)/g, '');
    }

    // Same synonym map as before, so "Cream" also matches "beige/khaki/sand" images etc.
    const colorSynonyms = {
        beige: ['beige', 'cream', 'khaki', 'sand'],
        cream: ['cream', 'beige', 'khaki', 'sand'],
        navy: ['navy', 'blue', 'dark-blue'],
        blue: ['blue', 'navy'],
        white: ['white', 'snow'],
        black: ['black', 'dark', 'charcoal'],
        grey: ['grey', 'gray'],
        gray: ['gray', 'grey']
    };

    // Make sure nothing is left hidden from any earlier filtering logic
    function ensureAllImagesVisible() {
        document.querySelectorAll('.product-gallery-slide.filtered-out').forEach(s => s.classList.remove('filtered-out'));
        document.querySelectorAll('.product-thumb.filtered-out').forEach(t => t.classList.remove('filtered-out'));
    }

    function goToColor(colorValue) {
        if (!colorValue) return;

        ensureAllImagesVisible();

        const colorHandle = handleize(colorValue);
        const activeKeywords = colorSynonyms[colorHandle] || [colorHandle];

        // Find the first slide whose alt-derived color or image URL matches
        const slides = Array.from(document.querySelectorAll('.product-gallery-slide'));
        const targetSlide = slides.find(slide => {
            const slideColor = (slide.dataset.color || '').toLowerCase();
            const img = slide.querySelector('img');
            const src = img && img.src ? img.src.toLowerCase() : '';
            return activeKeywords.some(k => slideColor.includes(k) || src.includes(k));
        });

        if (!targetSlide) return; // no matching image found, leave gallery as-is

        // Update active state
        document.querySelectorAll('.product-gallery-slide').forEach(s => s.classList.remove('active'));
        document.querySelectorAll('.product-thumb').forEach(t => t.classList.remove('active'));
        targetSlide.classList.add('active');

        const mediaId = targetSlide.dataset.mediaId;
        const targetThumb = mediaId
            ? document.querySelector('.product-thumb[data-media-id="' + mediaId + '"]')
            : null;
        if (targetThumb) targetThumb.classList.add('active');

        // Scroll the main gallery carousel to bring that slide into view
        targetSlide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });

        // Scroll the thumbnail strip too, if present
        if (targetThumb) {
            targetThumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
        }
    }

    // Capture phase so we still catch the click even if Pumper's own
    // Svelte handler calls stopPropagation() on the bubble phase.
    document.addEventListener('click', function (e) {
        const option = e.target.closest('.pumper_dropdown_option_text[data-pmpr-gt-option]');
        if (!option) return;

        const listbox = option.closest('[role="listbox"]');
        const label = listbox && listbox.getAttribute('aria-label');
        if (label !== 'Color') return; // ignore the size dropdown, only react to color

        goToColor(option.dataset.pmprGtOption);
    }, true);

    // On page load, sync the gallery to whatever color Pumper shows as
    // pre-selected (e.g. "Navy" by default). Pumper renders async, so
    // poll briefly until its trigger element shows up.
    function initFromPumper(attemptsLeft) {
        ensureAllImagesVisible(); // in case an old version of this script left things filtered

        const trigger = document.querySelector('.pumper_dropdown_trigger[aria-label^="Color:"]');
        if (trigger) {
            const initialColor = trigger.getAttribute('aria-label').replace('Color:', '').trim();
            goToColor(initialColor);
            return;
        }
        if (attemptsLeft > 0) {
            setTimeout(() => initFromPumper(attemptsLeft - 1), 300);
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => initFromPumper(15));
    } else {
        initFromPumper(15);
    }
})();

// (function () {
//     function handleize(str) {
//         return String(str)
//             .toLowerCase()
//             .replace(/[^a-z0-9]+/g, '-')
//             .replace(/(^-|-$)/g, '');
//     }

//     // Same synonym map as your existing theme logic, so behavior matches
//     const colorSynonyms = {
//         beige: ['beige', 'cream', 'khaki', 'sand'],
//         cream: ['cream', 'beige', 'khaki', 'sand'],
//         navy: ['navy', 'blue', 'dark-blue'],
//         blue: ['blue', 'navy'],
//         white: ['white', 'snow'],
//         black: ['black', 'dark', 'charcoal'],
//         grey: ['grey', 'gray'],
//         gray: ['gray', 'grey']
//     };

//     function filterGalleryByColor(colorValue) {
//         if (!colorValue) return;

//         const colorHandle = handleize(colorValue);
//         const activeKeywords = colorSynonyms[colorHandle] || [colorHandle];
//         let firstVisibleMediaId = null;

//         // Filter main gallery slides
//         document.querySelectorAll('.product-gallery-slide').forEach(slide => {
//             const slideColor = (slide.dataset.color || '').toLowerCase();
//             const img = slide.querySelector('img');
//             const src = img && img.src ? img.src.toLowerCase() : '';
//             const isMatch = activeKeywords.some(k => slideColor.includes(k) || src.includes(k));

//             if (isMatch) {
//                 slide.classList.remove('filtered-out');
//                 if (!firstVisibleMediaId && slide.dataset.mediaId) {
//                     firstVisibleMediaId = slide.dataset.mediaId;
//                 }
//             } else {
//                 slide.classList.add('filtered-out');
//             }
//         });

//         // Filter thumbnails to match
//         document.querySelectorAll('.product-thumb').forEach(thumb => {
//             const thumbColor = (thumb.dataset.color || '').toLowerCase();
//             const img = thumb.querySelector('img');
//             const src = img && img.src ? img.src.toLowerCase() : '';
//             const isMatch = activeKeywords.some(k => thumbColor.includes(k) || src.includes(k));
//             thumb.classList.toggle('filtered-out', !isMatch);
//         });

//         // If the currently active slide is no longer valid for this color, jump to the first matching one
//         const activeSlide = document.querySelector('.product-gallery-slide.active');
//         if ((!activeSlide || activeSlide.classList.contains('filtered-out')) && firstVisibleMediaId) {
//             const slide = document.querySelector('.product-gallery-slide[data-media-id="' + firstVisibleMediaId + '"]');
//             const thumb = document.querySelector('.product-thumb[data-media-id="' + firstVisibleMediaId + '"]');

//             document.querySelectorAll('.product-gallery-slide').forEach(s => s.classList.remove('active'));
//             document.querySelectorAll('.product-thumb').forEach(t => t.classList.remove('active'));

//             if (slide) slide.classList.add('active');
//             if (thumb) thumb.classList.add('active');
//         }
//     }

//     // Capture phase so we still catch the click even if Pumper's own
//     // Svelte handler calls stopPropagation() on the bubble phase.
//     document.addEventListener('click', function (e) {
//         const option = e.target.closest('.pumper_dropdown_option_text[data-pmpr-gt-option]');
//         if (!option) return;

//         const listbox = option.closest('[role="listbox"]');
//         const label = listbox && listbox.getAttribute('aria-label');
//         if (label !== 'Color') return; // ignore the size dropdown, only react to color

//         filterGalleryByColor(option.dataset.pmprGtOption);
//     }, true);

//     // On page load, sync the gallery to whatever color Pumper shows as
//     // pre-selected (e.g. "Navy" by default). Pumper renders async, so
//     // poll briefly until its trigger element shows up.
//     function initFromPumper(attemptsLeft) {
//         const trigger = document.querySelector('.pumper_dropdown_trigger[aria-label^="Color:"]');
//         if (trigger) {
//             const initialColor = trigger.getAttribute('aria-label').replace('Color:', '').trim();
//             filterGalleryByColor(initialColor);
//             return;
//         }
//         if (attemptsLeft > 0) {
//             setTimeout(() => initFromPumper(attemptsLeft - 1), 300);
//         }
//     }

//     if (document.readyState === 'loading') {
//         document.addEventListener('DOMContentLoaded', () => initFromPumper(15));
//     } else {
//         initFromPumper(15);
//     }
// })();